import Loader from '@components/common/Loader';
import DateSelect from '@components/main/DateSelect';
import Notice from '@components/main/Notice';
import NowTime from '@components/main/NowTime';
import SeverSelect from '@components/main/SeverSelect';
import { type IOptionProps } from '@interface/ICommon';
import { selectIsNowbtnClicked, setIsNowbtnClicked } from '@store/commonSlice';
import { useAppDispatch, useAppSelector } from '@store/index';
import { goNowTime } from '@utils/scheduleUtils';
import { useEffect, type FC } from 'react';
import Timetable from './Timetable';

const MainContainer: FC<{ props: IOptionProps }> = ({ props }) => {
    const { toggleAsideMenu, activeServerId, activeDate, serverListData, dateListData, evtListData, isFetching, refreshFn } = props;
    const dispatch = useAppDispatch();

    const isNowbtnClicked = useAppSelector(selectIsNowbtnClicked);

    useEffect(() => {
        goNowTime();
    }, []);

    useEffect(() => {
        if (isNowbtnClicked) {
            dispatch(setIsNowbtnClicked(false));
            goNowTime(100);
        }
    }, [evtListData]);

    return (
        <main className="lg:w-[calc(100%-310px)] relative">
            <section className="lg:flex lg:justify-between lg:items-center lg:pb-[8px]">
                <div className="flex justify-between px-[16px] bg-gray004 py-[19px] lg:px-0 lg:py-0 lg:bg-transparent">
                    <button className="text-bg w-[42px] h-[42px] bg-search lg:hidden" onClick={() => toggleAsideMenu(true)}></button>
                    <SeverSelect serverList={serverListData ? serverListData[0].servers : undefined} activeServerId={activeServerId} />
                </div>
                {isFetching || !evtListData?.schedule ? <Loader /> : null}
                <NowTime time={evtListData?.searchTime} refreshFn={refreshFn} />
            </section>
            <section>
                <DateSelect dateList={dateListData} activeDate={activeDate} />
                <Timetable
                    eventList={evtListData?.schedule}
                    searchTime={evtListData?.searchTime}
                    isFetching={isFetching}
                    activeDate={activeDate}
                />
                <Notice />
            </section>
        </main>
    );
};
export default MainContainer;
